<template>
  <div class="latest-news-container">
    <div class="main-container">
      <div class="news-header">
        <h2 class="news-title">{{ t('home.newslist.title') }}</h2>
        <router-link to="/news" class="more-link">
          <span>{{ t('home.newslist.more') }}</span>
          <div class="arrow-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-f316e37b=""><path d="M13 8.66671L16.3333 12L13 15.3334" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.3334 12L7.66675 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </div>
        </router-link>
      </div>

      <div class="news-list">
        <div 
          v-for="(item, index) in newsItems" 
          :key="index"
          class="news-item"
        >
          <!-- 图片区域 - 可点击跳转 -->
          <router-link :to="`/news/${item.id}`" class="news-image-link">
            <div class="news-image-wrapper">
              <img 
                :src="item.image" 
                :alt="item.title"
                class="news-image"
              />
            </div>
          </router-link>
          
          <!-- 内容区域 -->
          <div class="news-content">
            <!-- 时间 -->
            <div class="news-date">{{ item.date }}</div>
            
            <!-- 标题 - 可点击跳转 -->
            <router-link :to="`/news/${item.id}`" class="news-title-link">
              <h3 class="news-title">{{ item.title }}</h3>
            </router-link>
            
            <!-- 描述 -->
            <p class="news-description">{{ item.description }}</p>
            
            <!-- 了解详情按钮 -->
            <div class="learn-more-btn">
              <router-link :to="`/news/${item.id}`" class="read-more-link">
                <span>{{ t('home.newslist.readmore') }}</span>
                <div class="icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-f316e37b=""><path d="M13 8.66671L16.3333 12L13 15.3334" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.3334 12L7.66675 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n();
import img4 from "../../assets/image/home/tdb.webp";
import img5 from "../../assets/image/home/sweetprotein_102.jpg";

// 根据语言获取图片路径
const getImageByLang = (cnImage, enImage) => {
  return locale.value === 'en' ? enImage : cnImage;
};

// 使用计算属性来响应语言变化
// 使用计算属性来响应语言变化
const newsItems = computed(() => [
  {
    date: '2026-05-09 00:00',
    title: t('home.newslist.list.item8.title'),
    description: t('home.newslist.list.item8.description'),
    image: getImageByLang(
      'https://www.healthcode.com/media/news/260509/cab-18.png',
      'https://www.healthcode.com/media/news/260509/cba-18EN.png'
    ),
    id: '001', // 修改为 001
  },
  {
    date: '2026-04-16 00:00',
    title: t('home.newslist.list.item7.title'),
    description: t('home.newslist.list.item7.description'),
    image: getImageByLang(
      'https://www.healthcode.com/media/news/260427/4.webp',
      'https://www.healthcode.com/media/news/260427/4.webp'

    ),
    id: '002', // 修改为 002
  },
  {
    date: '2026-03-26 00:00',
    title: t('home.newslist.list.item6.title'),
    description: t('home.newslist.list.item6.description'),
    image: getImageByLang(
      'https://www.healthcode.com/media/news/haiqia/OIF2026.jpg',
      'https://www.healthcode.com/media/news/haiqia/OIF2026_EN.jpg'
    ),
    id: '003', // 修改为 003
  },
  {
    date: '2026-01-26 00:00',
    title: t('home.newslist.list.item5.title'),
    description: t('home.newslist.list.item5.description'),
    image: getImageByLang(
      img5,
      img5,
    ),
    id: '004', // 修改为 004
  },
  {
    date: '2025-11-15 00:00',
    title: t('home.newslist.list.item4.title'),
    description: t('home.newslist.list.item4.description'),
    image: getImageByLang(
      img4,
     img4,
    ),
    id: '005', // 修改为 005
  },
  {
    date: '2025-09-24 00:00',
    title: t('home.newslist.list.item1.title'),
    description: t('home.newslist.list.item1.description'),
    image: getImageByLang(
      'https://a.storyblok.com/f/287055582545350/1600x1066/c91da93edd/ciif-award.jpg/m/filters:format(webp):quality(85)',
      'https://a.storyblok.com/f/287055582545350/1600x1066/c91da93edd/ciif-award.jpg/m/filters:format(webp):quality(85)',
    ),
    id: '006', // 修改为 006
  },
  {
    date: '2025-07-22 00:00',
    title: t('home.newslist.list.item2.title'),
    description: t('home.newslist.list.item2.description'),
    image: getImageByLang(
      'https://a.storyblok.com/f/287055582545350/650x563/ecfa8946a1/bb957555d42c885d8cc4be94a5ab6adb48dc5500_size342_w650_h563.webp/m/filters:format(webp):quality(85)',
      'https://a.storyblok.com/f/287055582545350/650x563/ecfa8946a1/bb957555d42c885d8cc4be94a5ab6adb48dc5500_size342_w650_h563.webp/m/filters:format(webp):quality(85)',
    ),
    id: '007', // 修改为 007
  },
  {
    date: '2025-06-01 00:00',
    title: t('home.newslist.list.item3.title'),
    description: t('home.newslist.list.item3.description'),
    image: getImageByLang(
      'https://a.storyblok.com/f/287055582545350/1748x1280/0a742a2eac/kangma-factory.jpg/m/filters:format(webp):quality(85)',
      'https://a.storyblok.com/f/287055582545350/1748x1280/0a742a2eac/kangma-factory.jpg/m/filters:format(webp):quality(85)',
    ),
    id: '008', // 修改为 008
  }
]);
</script>

<style scoped>
/* 样式保持不变 */
.latest-news-container {
  background: #f7f7f7;
  width: 100%;
  margin: 0 auto;
  padding: 6rem 0;
}

.news-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e9ecef;
}

.news-title {
  font-size: 2rem;
  font-weight: 400;
  color: #333;
  margin: 0;
}

.icon {
  background: #ffffff4d;
  border-radius: 50%;
  height: 1.6rem;
  margin-left: 0.8rem;
  transition: all 0.2s ease-in-out;
  width: 1.6rem;
}

.more-link {
  align-items: center;
  background: #000;
  border-radius: 2.4rem;
  color: #fffc;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-size: 1.1rem;
  height: 2.8rem;
  justify-content: center;
  padding-inline: 1rem 0.8rem;
  transition: all 0.2s ease-in-out;
  width: fit-content;
}

.more-link:hover {
  background-color: #444;
}

.news-list {
  display: flex;
  flex-direction: column;
}

.news-item {
  display: flex;
  gap: 2.4rem;
  padding: 1rem 0;
  border-bottom: 1px solid #e9ecef;
  padding-block: 4rem;
}

.news-image-link {
  display: block;
  text-decoration: none;
  color: inherit;
}

.news-image-wrapper {
  aspect-ratio: 552 / 311;
  border-radius: 1.2rem;
  overflow: hidden;
  position: relative;
  width: 35.2rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.news-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.news-title-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.news-title-link:hover .news-title {
  color: #000;
}

.news-content {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: space-between;
}

.news-date {
  font-size: 1.6rem;
  color: #999;
  margin: 0;
}

.news-content .news-title {
  font-size: 2rem;
  font-weight: 500;
  color: #999;
  margin: 3.2rem 0 0.6rem 0;
  line-height: 1.4;
  transition: color 0.3s ease;
  cursor: pointer;
}

.news-description {
  font-size: 1.6rem;
  color: #999;
  line-height: 1.5;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.learn-more-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.3rem;
  color: #000;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-top: 0.5rem;
  transition: all 0.3s ease;
}

.learn-more-btn a {
  display: flex;
  align-items: center;
}

.learn-more-btn .icon {
  background: #0000004d;
  color: #fff;
}

.learn-more-btn:hover {
  color: #333;
  opacity: 0.8;
}

.news-item:hover .news-content .news-title {
  color: #000;
}

.news-item:hover .news-image-wrapper {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.news-item:hover .news-image {
  transform: scale(1.05);
}

@media (max-width: 992px) {
  .news-item {
    flex-direction: column;
  }

  .news-image-wrapper {
    min-width: auto;
    width: 100%;
    height: 20rem;
  }

  .news-content {
    margin-top: 1rem;
  }
}

@media (max-width: 768px) {
  .latest-news-container {
    padding: 1rem 0;
  }

  .news-header {
    flex-direction: row;
    gap: 1rem;
    text-align: center;
    padding: 2rem 0;
  }

  .news-content .news-title {
    font-size: 1.6rem;
    margin: 1.2rem 0 0.6rem 0;
  }

  .news-description {
    font-size: 1.4rem;
  }

  .news-item {
    gap: 1rem;
    padding-block: 3rem;
  }

  .news-image-wrapper {
    height: 20rem;
  }
}
</style>